import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill-new';
// import 'react-quill-new/dist/quill.snow.css';
import DashboardLayout from '../../components/admin/DashboardLayout';
import MediaManager from '../../components/admin/MediaManager';
import {
  Plus, Trash2, Briefcase, CheckCircle2, XCircle,
  Loader2, X, Users, FileText,
  Star, PenTool, Monitor,
  Scissors, Shirt, Ruler, Factory, Truck, Package, ClipboardList, Tag, ShoppingBag, Pencil,
  Image as ImageIcon
} from 'lucide-react';
import { useNotification } from '../../context/NotificationContext';import DeleteConfirmationModal from '../../components/admin/DeleteConfirmationModal'; // New import

const iconOptions = [
  { name: 'briefcase', icon: <Briefcase size={24} />, label: 'Umum / Kantor' },
  { name: 'scissors', icon: <Scissors size={24} />, label: 'Potong / Pola' },
  { name: 'shirt', icon: <Shirt size={24} />, label: 'Jahit / Produk' },
  { name: 'ruler', icon: <Ruler size={24} />, label: 'Pengukuran' },
  { name: 'factory', icon: <Factory size={24} />, label: 'Produksi Massal' },
  { name: 'truck', icon: <Truck size={24} />, label: 'Logistik / Kirim' },
  { name: 'package', icon: <Package size={24} />, label: 'Packing' },
  { name: 'clipboard-list', icon: <ClipboardList size={24} />, label: 'Quality Control' },
  { name: 'tag', icon: <Tag size={24} />, label: 'Merchandiser' },
  { name: 'shopping-bag', icon: <ShoppingBag size={24} />, label: 'Sales / Marketing' },
  { name: 'users', icon: <Users size={24} />, label: 'HR / Team' },
  { name: 'pen-tool', icon: <PenTool size={24} />, label: 'Desain Grafis' },
  { name: 'monitor', icon: <Monitor size={24} />, label: 'IT / Admin' },
  { name: 'star', icon: <Star size={24} />, label: 'Management' },
];

const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{'list': 'ordered'}, {'list': 'bullet'}]
  ]
};

const LokerManager = () => {
  const { addNotification } = useNotification();
  const [vacancies, setVacancies] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Modals
  const [showModal, setShowModal] = useState(false);
  const [showApplicantsModal, setShowApplicantsModal] = useState(false);
  const [showIconModal, setShowIconModal] = useState(false);
  
  // Delete Confirmation State
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [currentJobApplicants, setCurrentJobApplicants] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Media Manager
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [mediaCallback, setMediaCallback] = useState(null);

  // Form State
  const [coverType, setCoverType] = useState('image'); // 'image' or 'icon'
  const [formData, setFormData] = useState({
    title: '',
    position: '',
    job_type: 'Full-time',
    description: '',
    requirements: '',
    expiry_date: '',
    no_expiry: false,
    is_active: 1,
    icon_name: 'briefcase',
    cover_image: null, // File object (for new upload)
    existing_cover_image: '' // URL string (from media manager)
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    fetchVacancies();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchVacancies = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL || 'https://konveksiimoonusel.com/api'}/admin/loker.php`);
      setVacancies(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchApplicants = async (jobId) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL || 'https://konveksiimoonusel.com/api'}/admin/applicants.php?job_id=${jobId}`);
      setCurrentJobApplicants(res.data);
      setShowApplicantsModal(true);
    } catch (err) {
      addNotification('Gagal memuat pelamar', 'error');
    }
  };

  const handleMediaSelect = (url) => {
    setFormData(prev => ({
      ...prev,
      existing_cover_image: url,
      cover_image: null // Clear file input if library image is selected
    }));
    setShowMediaModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const data = new FormData();
    data.append('title', formData.title);
    data.append('position', formData.position);
    data.append('job_type', formData.job_type);
    data.append('description', formData.description);
    data.append('requirements', formData.requirements);
    data.append('is_active', formData.is_active);
    data.append('no_expiry', formData.no_expiry);
    if (formData.id) data.append('id', formData.id);
    if (!formData.no_expiry) data.append('expiry_date', formData.expiry_date);
    
    if (coverType === 'image') {
      if (formData.cover_image) {
        data.append('cover_image', formData.cover_image);
      } else if (formData.existing_cover_image) {
        data.append('existing_cover_image', formData.existing_cover_image);
      }
    } else {
      data.append('icon_name', formData.icon_name);
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL || 'https://konveksiimoonusel.com/api'}/admin/loker.php`, data, {
         headers: { 'Content-Type': 'multipart/form-data' }
      });
      setShowModal(false);
      setFormData({
        title: '', position: '', job_type: 'Full-time', description: '',
        requirements: '', expiry_date: '', no_expiry: false, is_active: 1,
        icon_name: 'briefcase', cover_image: null
      });
      addNotification('Loker berhasil disimpan!', 'success');
      fetchVacancies();
    } catch (err) {
      addNotification('Gagal menyimpan loker', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleEdit = (vacancy) => {
    // Check if cover_image is a full URL or just a filename
    let existingImg = '';
    const apiBase = process.env.REACT_APP_API_URL || 'https://konveksiimoonusel.com/api';
    const webBase = apiBase.replace('/api', '');

    if (vacancy.cover_image) {
      if (vacancy.cover_image.startsWith('http')) {
        existingImg = vacancy.cover_image;
      } else {
        existingImg = `${webBase}/uploads/loker/${vacancy.cover_image}`;
      }
    }

    setFormData({
      id: vacancy.id,
      title: vacancy.title || '',
      position: vacancy.position || '',
      job_type: vacancy.job_type || 'Full-time',
      description: vacancy.description || '',
      requirements: vacancy.requirements || '',
      expiry_date: vacancy.expiry_date || '',
      no_expiry: !vacancy.expiry_date,
      is_active: vacancy.is_active,
      icon_name: vacancy.icon_name || 'briefcase',
      cover_image: null,
      existing_cover_image: existingImg
    });
    setCoverType(vacancy.icon_name ? 'icon' : 'image');
    setShowModal(true);
  };

  // Trigger Delete Modal
  const handleDelete = (id) => {
    setDeleteTargetId(id);
    setShowDeleteModal(true);
  };

  // Actual Delete Action
  const confirmDelete = async () => {
    if (!deleteTargetId) return;
    setDeleting(true);
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL || 'https://konveksiimoonusel.com/api'}/admin/loker.php?id=${deleteTargetId}`);
      setVacancies(vacancies.filter(v => v.id !== deleteTargetId));
      addNotification('Loker dihapus', 'success');
      setShowDeleteModal(false);
      setDeleteTargetId(null);
    } catch (err) {
      addNotification('Gagal menghapus loker', 'error');
    } finally {
      setDeleting(false);
    }
  };

    const styles = {
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' },
    title: { fontSize: '1.5rem', fontWeight: '700', letterSpacing: '-0.02em', color: '#111' },
    addBtn: { 
      backgroundColor: '#000', color: '#fff', padding: '0.6rem 1.2rem', 
      borderRadius: '0.5rem', border: '1px solid #000', cursor: 'pointer', 
      display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: '500', fontSize: '0.9rem',
      transition: 'all 0.2s'
    },
    // Changed to List View (Stack)
    grid: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
    // Row Card Style
    card: { 
      backgroundColor: '#fff', 
      border: '1px solid #f3f4f6', 
      display: 'flex', 
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'flex-start' : 'center',
      padding: '1rem', 
      borderRadius: '0.75rem', // Slight rounding like Articles
      gap: '1rem',
      transition: 'all 0.2s ease'
    },
    // Small Thumbnail
    thumbContainer: {
      width: isMobile ? '100%' : '80px', 
      height: isMobile ? '150px' : '80px', 
      minWidth: isMobile ? 'auto' : '80px',
      backgroundColor: '#f9fafb', 
      borderRadius: '0.5rem',
      border: '1px solid #f3f4f6',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      overflow: 'hidden'
    },
    // Content Middle
    cardContent: { flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' },
    jobTitle: { fontSize: '1.1rem', fontWeight: '600', color: '#111', marginBottom: '0.25rem' },
    jobMeta: { fontSize: '0.85rem', color: '#666', display: 'flex', alignItems: 'center', gap: '0.5rem' },
    
    // Actions Right
    actions: { 
      display: 'flex', 
      alignItems: 'center', 
      gap: '1rem',
      marginTop: isMobile ? '1rem' : '0',
      width: isMobile ? '100%' : 'auto',
      justifyContent: isMobile ? 'space-between' : 'flex-end'
    },
    
    badge: (active) => ({
      padding: '0.25rem 0.75rem', borderRadius: '99px', fontSize: '0.7rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em',
      backgroundColor: active ? '#f0fdf4' : '#fef2f2',
      color: active ? '#15803d' : '#b91c1c',
      display: 'inline-flex', alignItems: 'center', gap: '0.25rem'
    }),
    
    // Modal
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, backdropFilter: 'blur(5px)' },
    modal: { 
      backgroundColor: '#fff', padding: '2.5rem', width: '90%', maxWidth: '700px', maxHeight: '90vh', overflowY: 'auto', 
      borderRadius: '1rem', border: '1px solid #e5e5e5', boxShadow: '0 20px 50px rgba(0,0,0,0.1)' 
    },
    formGrid: { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1.5rem' },
    inputGroup: { marginBottom: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' },
    input: { padding: '0.75rem', border: '1px solid #e5e5e5', borderRadius: '0.5rem', outline: 'none', transition: 'border-color 0.2s', fontSize: '0.9rem', width: '100%' },
    label: { fontSize: '0.75rem', fontWeight: '600', textTransform: 'uppercase', color: '#888', letterSpacing: '0.05em', marginBottom: '0.25rem' },
    
    // Quill Custom Style
    quillContainer: { height: '250px', marginBottom: '3.5rem', display: 'flex', flexDirection: 'column' },

    // Icon Picker
    iconGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(70px, 1fr))', gap: '0.75rem', marginTop: '1rem' },
    iconItem: (selected) => ({
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '0.75rem',
      border: selected ? '1px solid #000' : '1px solid #eee', borderRadius: '0.5rem', cursor: 'pointer',
      backgroundColor: selected ? '#f9f9f9' : '#fff', transition: 'all 0.2s'
    }),

    // Applicants
    applicantItem: { padding: '1rem', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    cvBtn: { padding: '0.4rem 0.8rem', backgroundColor: '#000', color: '#fff', borderRadius: '0.5rem', textDecoration: 'none', fontSize: '0.75rem', fontWeight: '500' }
  };

  const selectedIconObj = iconOptions.find(i => i.name === formData.icon_name) || iconOptions[0];

  return (
    <DashboardLayout>
      <MediaManager 
        isOpen={showMediaModal} 
        onClose={() => setShowMediaModal(false)} 
        onSelect={handleMediaSelect}
      />

      <div style={styles.header}>
        <h1 style={styles.title}>Lowongan Kerja</h1>
        <button style={styles.addBtn} onClick={() => setShowModal(true)}>
          <Plus size={16} /> Buat Baru
        </button>
      </div>

      {loading ? <div>Memuat data...</div> : (
        <div style={styles.grid}>
          {vacancies.map(v => (
            <div key={v.id} style={styles.card}>
              
              {/* Thumbnail */}
              <div style={styles.thumbContainer}>
                {v.cover_image ? (
                   <img src={v.cover_image} alt="" style={{width:'100%', height:'100%', objectFit:'cover'}} />
                ) : (
                   <div style={{color:'#999'}}>{iconOptions.find(i=>i.name===v.icon_name)?.icon || <Briefcase size={24}/>}</div>
                )}
              </div>
              
              {/* Content */}
              <div style={styles.cardContent}>
                <div style={styles.jobTitle}>{v.title}</div>
                <div style={styles.jobMeta}>
                  <div style={styles.badge(Number(v.is_active) === 1)}>
                    {Number(v.is_active) === 1 ? 'Aktif' : 'Tutup'}
                  </div>
                  <span style={{color:'#ddd'}}>|</span>
                  <span>{v.position}</span>
                  <span style={{color:'#ddd'}}>|</span>
                  <span>{v.job_type}</span>
                </div>
              </div>
              
              {/* Actions */}
              <div style={styles.actions}>
                <button style={{background:'none', border:'1px solid #eee', borderRadius:'0.5rem', padding:'0.4rem 0.8rem', cursor:'pointer', display:'flex', alignItems:'center', gap:'0.4rem', fontSize:'0.8rem', fontWeight:'500', color:'#444'}} onClick={() => fetchApplicants(v.id)}>
                  <Users size={14} /> {v.applicants_count || '0'} Pelamar
                </button>
                <div style={{display: 'flex', gap: '0.5rem'}}>
                  <button style={{width:'32px', height:'32px', display:'flex', alignItems:'center', justifyContent:'center', background:'#f9fafb', border:'1px solid #eee', borderRadius:'0.5rem', color:'#2563eb', cursor:'pointer'}} onClick={() => handleEdit(v)}>
                    <Pencil size={16} />
                  </button>
                  <button style={{width:'32px', height:'32px', display:'flex', alignItems:'center', justifyContent:'center', background:'#fef2f2', border:'1px solid #fee2e2', borderRadius:'0.5rem', color:'#ef4444', cursor:'pointer'}} onClick={() => handleDelete(v.id)}>
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>

            </div>
          ))}
        </div>
      )}

      {/* Job Form Modal */}
      {showModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={{display:'flex', justifyContent:'space-between', marginBottom:'1.5rem'}}>
              <h3>{formData.id ? 'Edit Loker' : 'Tambah Loker Baru'}</h3>
              <button onClick={() => setShowModal(false)} style={{border:'none', background:'none', cursor:'pointer'}}><X /></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div style={styles.formGrid}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Judul Loker</label>
                  <input style={styles.input} value={formData.title} onChange={e => setFormData({...formData, title: e.target.value})} required placeholder="Contoh: Staff Jahit"/>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Posisi / Divisi</label>
                  <input style={styles.input} value={formData.position} onChange={e => setFormData({...formData, position: e.target.value})} required placeholder="Contoh: Produksi"/>
                </div>
              </div>

              <div style={styles.formGrid}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Tipe Pekerjaan</label>
                  <select style={styles.input} value={formData.job_type} onChange={e => setFormData({...formData, job_type: e.target.value})}>
                    <option value="Full-time">Full-time</option>
                    <option value="Part-time">Part-time</option>
                    <option value="Freelance">Freelance</option>
                    <option value="Internship">Magang</option>
                  </select>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Cover Job</label>
                  <div style={{display:'flex', gap:'0.5rem', marginBottom:'0.5rem'}}>
                     <button type="button" onClick={() => setCoverType('image')} style={{padding:'0.25rem 0.5rem', border: coverType==='image'?'1px solid #000':'1px solid #eee', borderRadius:'4px', background: coverType==='image'?'#eee':'#fff', cursor: 'pointer'}}>Image Cover</button>
                     <button type="button" onClick={() => setCoverType('icon')} style={{padding:'0.25rem 0.5rem', border: coverType==='icon'?'1px solid #000':'1px solid #eee', borderRadius:'4px', background: coverType==='icon'?'#eee':'#fff', cursor: 'pointer'}}>Icon Cover</button>
                  </div>
                  
                  {coverType === 'image' ? (
                    <div style={{border:'1px solid #e5e7eb', borderRadius:'0.5rem', padding:'0.5rem'}}>
                      <div 
                        onClick={() => setShowMediaModal(true)}
                        style={{
                          padding: '1.5rem', border: '2px dashed #d1d5db', borderRadius: '0.5rem', 
                          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
                          cursor: 'pointer', backgroundColor: '#f9fafb', color: '#6b7280'
                        }}
                      >
                        <ImageIcon size={24} />
                        <span style={{marginTop:'0.5rem', fontSize:'0.85rem', fontWeight:'500'}}>
                          {formData.existing_cover_image ? 'Ganti Gambar' : 'Pilih dari Library'}
                        </span>
                      </div>
                      
                      {formData.existing_cover_image && (
                        <div style={{marginTop:'0.5rem'}}>
                          <img 
                            src={formData.existing_cover_image} 
                            alt="Cover Preview" 
                            style={{width:'100%', height:'150px', objectFit:'cover', borderRadius:'0.5rem'}} 
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <button 
                      type="button"
                      onClick={() => setShowIconModal(true)}
                      style={{
                        width: '100%', padding: '0.75rem', border: '1px dashed #999', borderRadius: '0.5rem',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', background: '#f9f9f9', cursor: 'pointer'
                      }}
                    >
                      {selectedIconObj.icon}
                      <span>{selectedIconObj.label} (Klik untuk ganti)</span>
                    </button>
                  )}
                </div>
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Deskripsi Pekerjaan</label>
                <div style={styles.quillContainer}>
                  <ReactQuill 
                    theme="snow" 
                    value={formData.description} 
                    onChange={val => setFormData(prev => ({...prev, description: val}))} 
                    modules={quillModules}
                    style={{height: '100%'}} 
                  />
                </div>
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Pengalaman & Syarat</label>
                <div style={styles.quillContainer}>
                  <ReactQuill 
                    theme="snow" 
                    value={formData.requirements} 
                    onChange={val => setFormData(prev => ({...prev, requirements: val}))} 
                    modules={quillModules}
                    style={{height: '100%'}}
                  />
                </div>
              </div>

              <div style={styles.formGrid}>
                 <div style={styles.inputGroup}>
                    <label style={styles.label}>Expired Date</label>
                    <input type="date" style={styles.input} disabled={formData.no_expiry} value={formData.expiry_date} onChange={e => setFormData({...formData, expiry_date: e.target.value})} />
                 </div>
                 <div style={{...styles.inputGroup, justifyContent:'center'}}>
                    <label style={{display:'flex', alignItems:'center', gap:'0.5rem', cursor:'pointer'}}>
                      <input type="checkbox" checked={formData.no_expiry} onChange={e => setFormData({...formData, no_expiry: e.target.checked})} />
                      Tanpa Batas Waktu
                    </label>
                 </div>
              </div>

              <div style={{display:'flex', justifyContent:'flex-end', gap:'1rem', marginTop:'1rem'}}>
                <button type="button" onClick={() => setShowModal(false)} style={{...styles.addBtn, backgroundColor:'#e5e7eb', color:'#000'}}>Batal</button>
                <button type="submit" style={{...styles.addBtn, opacity: submitting ? 0.7 : 1}} disabled={submitting}>
                  {submitting ? <Loader2 className="animate-spin" /> : 'Simpan Loker'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Icon Picker Modal */}
      {showIconModal && (
        <div style={styles.overlay}>
          <div style={{...styles.modal, maxWidth: '600px'}}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1rem'}}>
              <h3>Pilih Icon Cover</h3>
              <button onClick={() => setShowIconModal(false)} style={{border:'none', background:'none', cursor:'pointer'}}><X /></button>
            </div>
            <div style={{maxHeight: '60vh', overflowY: 'auto'}}>
               <div style={styles.iconGrid}>
                  {iconOptions.map(opt => (
                    <div 
                      key={opt.name} 
                      onClick={() => {
                        setFormData({...formData, icon_name: opt.name});
                        setShowIconModal(false);
                      }}
                      style={styles.iconItem(formData.icon_name === opt.name)}
                    >
                      {opt.icon}
                      <span style={{fontSize:'0.7rem', marginTop:'0.5rem', textAlign:'center'}}>{opt.label}</span>
                    </div>
                  ))}
               </div>
            </div>
          </div>
        </div>
      )}

      {/* Applicants Modal */}
      {showApplicantsModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={{display:'flex', justifyContent:'space-between', marginBottom:'1.5rem'}}>
              <h3>Daftar Pelamar</h3>
              <button onClick={() => setShowApplicantsModal(false)} style={{border:'none', background:'none', cursor:'pointer'}}><X /></button>
            </div>
            
            {currentJobApplicants.length === 0 ? (
              <div style={{textAlign:'center', padding:'2rem', color:'#666'}}>Belum ada pelamar untuk posisi ini.</div>
            ) : (
              <div>
                {currentJobApplicants.map(app => (
                  <div key={app.id} style={styles.applicantItem}>
                    <div>
                      <div style={{fontWeight:'700'}}>{app.name}</div>
                      <div style={{fontSize:'0.9rem', color:'#555', margin:'0.25rem 0'}}>{app.message || 'Tidak ada pesan.'}</div>
                      <div style={{fontSize:'0.75rem', color:'#999'}}>{new Date(app.created_at).toLocaleString()}</div>
                    </div>
                    <a href={app.cv_url} target="_blank" rel="noreferrer" style={styles.cvBtn}>
                      <FileText size={14} style={{marginRight:'4px', verticalAlign:'middle'}}/>
                      Lihat CV
                    </a>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        isConfirming={deleting}
        targetName={vacancies.find(v => v.id === deleteTargetId)?.title || 'lowongan ini'}
      />
    </DashboardLayout>
  );
};

export default LokerManager;
